<template>
  <div>
    <time-line></time-line>
    <apply
      title="留学申请"
      adCode="872"
      :applyList="applyList"
      typeId="9613,9612,9590,10969,9591"
      newsTitle="申请指南"
    ></apply>
    <ad-model :adCode="389" class="advertise"></ad-model>
    <chuguo
      title="出国必考"
      adCode="873"
      :overseasList="overseasList"
      typeId="1066,1067,1068,1079,1080"
      newsTitle="雅思托福"
    ></chuguo>
    <youxue></youxue>
  </div>
</template>

<script>
import Apply from './Apply'
import Chuguo from './Chuguo.vue'
import TimeLine from './TimeLine.vue'
import Youxue from './Youxue.vue'
import AdModel from '@/common-components/AdModel'
export default {
  name: 'gobroadMainfloor',
  components: {
    Apply,
    AdModel,
    TimeLine,
    Chuguo,
    Youxue
  },
  data () {
    return {
      countryList: [
        {
          cat_id: 1,
          country: '美国'
        },
        {
          cat_id: 2,
          country: '加拿大'
        },
        {
          cat_id: 3,
          country: '澳洲'
        },
        {
          cat_id: 4,
          country: '英国'
        },
        {
          cat_id: 5,
          country: '香港'
        },
        {
          cat_id: 6,
          country: '新西兰'
        },
        {
          cat_id: 7,
          country: '亚洲'
        },
        {
          cat_id: 8,
          country: '欧洲'
        }
      ],
      applyList: [
        {
          cnName: '美国',
          enName: 'America'
        },
        {
          cnName: '英国',
          enName: 'England'
        },
        {
          cnName: '加拿大',
          enName: 'Canada'
        },
        {
          cnName: '澳洲',
          enName: 'Australia'
        },
        {
          cnName: '新西兰',
          enName: 'NewZealand'
        },
        {
          cnName: '欧洲',
          enName: 'Eurasia'
        }
      ],
      overseasList: [
        {
          code: 154,
          cnName: '托福'
        },
        {
          code: 186,
          cnName: '雅思'
        },
        {
          code: 155,
          cnName: 'GRE'
        }
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.advertise >>> #adMod_389
  width 1200px !important
  margin 40px auto
</style>



// WEBPACK FOOTER //
// src/pages/gobroad/components/mainfloor/Mainfloor.vue